type GetSaveConfigKeyParams = {
  glsLocationIds: string[];
  userId: string;
};

export const getSaveConfigKey = ({ glsLocationIds, userId }: GetSaveConfigKeyParams) => {
  return `analytics-reporting-last-used-config-user[${userId}]-locations[${glsLocationIds.sort().join(',')}]`;
};

export const getDownloadStatusKey = ({ glsLocationIds, userId }: GetSaveConfigKeyParams) => {
  return `analytics-reporting-last-download-status-user[${userId}]-locations[${glsLocationIds.sort().join(',')}]`;
};
